// Id elementu <main> — cel linku „Przejdź do treści”.
export const MAIN_CONTENT_ID = 'tresc'
